import { CAPTCHA_SITEKEY } from './recaptcha_utils';

const verificationError = () => ({ responseJSON: ['Your message could not be verified. Please try again, or contact us by phone or email.'] });
let captchaReady;

function loadCaptcha() {
  if (captchaReady) return captchaReady;
  captchaReady = new Promise((resolve, reject) => {
    let timer, poll, ownedScript;
    const finish = error => {
      clearTimeout(timer); clearInterval(poll);
      if (error) { ownedScript?.remove(); reject(verificationError()); }
      else resolve(window.grecaptcha);
    };
    const check = () => {
      if (window.grecaptcha?.ready && window.grecaptcha?.execute) {
        clearInterval(poll);
        window.grecaptcha.ready(() => finish());
      }
    };
    timer = setTimeout(() => finish(true), 15000);
    if (!window.grecaptcha && !document.querySelector('script[src*="/recaptcha/api.js"]')) {
      ownedScript = document.createElement('script');
      ownedScript.src = `https://www.google.com/recaptcha/api.js?render=${CAPTCHA_SITEKEY}`;
      ownedScript.async = true; ownedScript.defer = true;
      ownedScript.onerror = () => finish(true);
      document.head.appendChild(ownedScript);
    }
    poll = setInterval(check, 100);
    check();
  }).catch(error => { captchaReady = null; throw error; });
  return captchaReady;
}

async function formCaptchaToken(action) {
  const captcha = await loadCaptcha();
  // Generate a fresh token at submission; Google tokens expire and are single-use.
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(verificationError()), 15000);
    Promise.resolve().then(() => captcha.execute(CAPTCHA_SITEKEY, { action }))
      .then(token => { clearTimeout(timer); token ? resolve(token) : reject(verificationError()); })
      .catch(() => { clearTimeout(timer); reject(verificationError()); });
  });
}

export const contactCaptchaToken = () => formCaptchaToken('contact_message');
export const checkoutRecoveryCaptchaToken = () => formCaptchaToken('checkout_recovery');
export const discountCaptchaToken = () => formCaptchaToken('discount_signup').catch(() => {
  throw { responseJSON: ['We could not verify your signup. Please try again, or contact us for help.'] };
});
